import { posicionarSeta, TAMANHO_DA_SETA } from './posicao';
import { Z_TUTORIAL } from './TutorialContext';

/** Classe literal por lado: o Tailwind e o CSS só conhecem nome escrito por inteiro. */
const CUTUCAO = {
  top: 'tutorial-cutuca-baixo',
  bottom: 'tutorial-cutuca-cima',
  left: 'tutorial-cutuca-direita',
  right: 'tutorial-cutuca-esquerda',
};

/** Para onde a ponta olha, dado o lado em que o balão ficou. */
const ROTACAO = { top: 0, bottom: 180, left: 270, right: 90 };

/** Seta cheia que aponta o alvo. Fica um nível acima do balão para não sumir atrás dele. */
const Seta = ({ rect, lado, animar = false }) => {
  const { top, left } = posicionarSeta(rect, lado);

  return (
    <div
      aria-hidden="true"
      className={`fixed pointer-events-none ${animar ? 'tutorial-desliza' : ''} ${CUTUCAO[lado]}`}
      style={{ top, left, zIndex: Z_TUTORIAL + 1 }}
    >
      <svg
        width={TAMANHO_DA_SETA}
        height={TAMANHO_DA_SETA}
        viewBox="0 0 24 24"
        style={{ transform: `rotate(${ROTACAO[lado]}deg)` }}
      >
        <path
          d="M12 22 L4 11 h4.5 V2 h7 v9 H20 Z"
          fill="rgba(0,0,0,0.55)"
          stroke="rgba(0,0,0,0.55)"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <path
          d="M12 22 L4 11 h4.5 V2 h7 v9 H20 Z"
          className="tutorial-seta"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default Seta;
